<div class="tw-grid tw-grid-cols-2 tw-gap-4">
  @for (option of options(); track $index) {
    <div role="button" tabindex="0"
      class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-p-2 tw-rounded-lg tw-border tw-border-solid tw-cursor-pointer"
      [class.tw-bg-teal-100]="isSelected($index)"
      [class.tw-border-teal-600]="isSelected($index)"
      [class.tw-bg-gray-75]="!isSelected($index)"
      [class.tw-border-gray-200]="!isSelected($index)"
      [attr.aria-disabled]="disabled()"
      [attr.aria-pressed]="isSelected($index)"
      (click)="onOptionClick($index)"
      (keydown.enter)="onOptionKeydown($index, $event)"
      (keydown.space)="onOptionKeydown($index, $event)">
      <span class="tw-relative tw-w-full tw-aspect-quiz-image tw-rounded-md tw-overflow-hidden tw-flex tw-items-center tw-justify-center"
        [class.tw-bg-gray-75]="isSelected($index)"
        [class.tw-bg-gray-80]="!isSelected($index)">
        @if (showIndex() && $index > 0) {
          <span class="tw-absolute tw-top-1 tw-left-1 tw-w-4 tw-h-4 tw-rounded-full tw-bg-gray-200 tw-flex tw-items-center tw-justify-center tw-text-100 tw-text-gray-500">{{ $index }}</span>
        }
        @if (imageUrl(option)) {
          <img class="tw-w-full tw-h-full tw-object-contain" [src]="imageUrl(option)" [alt]="optionLabel(option)" />
        }
      </span>
      <p class="tw-shrink-0 tw-w-full tw-my-auto tw-line-clamp-2 tw-text-300 tw-text-center tw-font-lexend tw-text-black">{{option.text}}</p>
    </div>
  }
</div>
